export default __webpack_public_path__ + "static/media/logo-col.899bda92.svg";